import React, { useState, useEffect } from "react";
import arrayToTree from "array-to-tree";
import CheckboxTree from "react-checkbox-tree";

const Groups = ({ register, checkedGroups, hierarchyVisible, hierarchyFolded, groups, setValue }) => {
  const [checked, setChecked] = useState(checkedGroups || []);
  const [expanded, setExpanded] = useState(hierarchyVisible && !hierarchyFolded ? groups.map((g) => g.id) : []);
  const groupsList = groups.map((g) => ({
    id: g.id,
    value: g.id,
    parent: g.parent,
    label: g.name + (g.description ? ` (${g.description})` : ""),
  }));

  return (
    <CheckboxTree
      nodes={hierarchyVisible ? arrayToTree(groupsList, { parentProperty: "parent" }) : groupsList}
      checked={checked}
      expanded={expanded}
      onCheck={(checked) => {
        register("groups", { value: checked });
        setChecked(checked);
        setValue("groups", checked);
      }}
      onExpand={(expanded) => setExpanded(expanded)}
      noCascade={true}
      iconsClass="fa5"
    />
  );
};

export default Groups;
